import { SnmpDestination } from 'data/snmp/snmp.types';

export default function adaptGridRowData(data: SnmpDestination[]) {
  return data.map((d) => {
    return {
      ...d
    };
  });
}

export function getIPVersion(ip: string): 'IPv4' | 'IPv6' | 'Invalid' {
  const ipv4Regex =
    /^(25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})(\.(25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})){3}$/;
  const ipv6Regex =
    /^(([0-9a-fA-F]{1,4}):){7}([0-9a-fA-F]{1,4})$/;

  if (ipv4Regex.test(ip)) return 'IPv4';
  if (ipv6Regex.test(ip)) return 'IPv6';
  return 'Invalid';
}
